import bsCustomFileInput from 'bs-custom-file-input'

export function init() {
  bsCustomFileInput.init()
}